import axios from 'axios';
import { useEffect, useState } from 'react';
import { apiErrorMessage } from '../apiError';
import { getAPIURL } from '../host';
import MusicSheet, { MusicSheetAsJSON } from '../models/MusicSheet';

/**
 * The selected sheet with its MusicXML. A failed request is reported instead of leaving the sheet loading forever
 * (audit F09), and a slower answer for an earlier selection never replaces the current one.
 */
const useMusicSheet = (musicSheetID: string | undefined) => {
  const [musicSheet, setMusicSheet] = useState<MusicSheet>();
  const [error, setError] = useState<string>();
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    if (!musicSheetID) return;

    let isCurrent = true;
    setError(undefined);
    axios
      .get<MusicSheetAsJSON>(`${getAPIURL()}/music-sheets/${musicSheetID}`)
      .then(
        ({ data }) =>
          isCurrent &&
          setMusicSheet(
            new MusicSheet(
              data.id,
              data.fileContents,
              data.numberOfMeasures,
              data.lastOffset,
              data.title,
              data.composer,
              data.category
            )
          )
      )
      .catch((reason) => isCurrent && setError(apiErrorMessage(reason)));

    return () => {
      isCurrent = false;
    };
  }, [musicSheetID, attempt]);

  return { error, musicSheet, retry: () => setAttempt((count) => count + 1) };
};

export default useMusicSheet;
